import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Modal } from 'antd';
import { Grid, Card } from '@material-ui/core';
import MainContainer from '../../../components/MainContainer';
import DiningList from './DiningList';
import DiningUpdate from './DiningUpdate';

@inject(
    'loginStore',
    'CmsLanguageStore',
    'CmsDiningStore'
)
@observer
class DiningPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        this.props.loginStore.authenticateAdmin().then(response => {
          if (!response) {
            this.props.history.push('/admin/login');
          }
        });
        
        this.props.CmsDiningStore.getAll();
        this.props.CmsLanguageStore.getActives();
    }

    componentWillUnmount() {
        this.props.CmsDiningStore.setshowModal(false);
    }

    cancelModal = () => {
        this.props.CmsDiningStore.setshowModal(false);
    }

    render() {
        const {
            showModal,
            modalTitle
        } = this.props.CmsDiningStore;

        return (
            <MainContainer title='Dining Management' menukey='dinings'>
                <Modal
                    title={modalTitle}
                    visible={showModal}
                    width={800}
                    footer={null}
                    onCancel={this.cancelModal}
                    zIndex={1000}
                >
                    <DiningUpdate />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: 'auto' }}>
                            <DiningList />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default DiningPage